import { Realtor } from "@/store/realtorState";
import { useAxios } from "../../../../hooks/useAxios";
import { API_IS_VALIDTOKEN } from "../../../../types/endpoint";

interface IUpload {
  token: string;
}

interface IDownload {
  status: string | null;
  message: string | null;
  result: {
    token: string;
    fe_color_main: string;
    fe_color_sub: string;
    fe_logo_text: string;
    fe_logo_type: string;
    fe_logo_url: null | string;
    fe_required_consideration: boolean;
    fe_required_email: boolean;
    fe_required_message: boolean;
    fe_required_name: boolean;
    fe_required_phone: boolean;
    fe_url_contact: string;
    fe_url_privacy_policy: string;
    fe_valuation_type: string;
    fe_display_title: boolean;
    fe_display_result_link: boolean;
  };
}

type IStored = Realtor;

function processing(input: IDownload) {
  const t = input.result;

  let deal_types = ["sale"];
  if (t.fe_valuation_type === "both") {
    deal_types = ["sale", "rent"];
  } else if (t.fe_valuation_type === "sale") {
    deal_types = ["sale"];
  } else if (t.fe_valuation_type === "rent") {
    deal_types = ["rent"];
  }

  const item: IStored = {
    isvalid: true,
    token: t.token,
    header: {
      logo: t.fe_logo_url,
      text: t.fe_logo_text,
    },
    deal_types: deal_types,
    required: {
      email: t.fe_required_email,
      name: t.fe_required_name,
      phone: t.fe_required_phone,
    },
    link: {
      privacy_policy: t.fe_url_privacy_policy,
      access: t.fe_url_contact
    },
    display:{
      title:t.fe_display_title,
      result_url:t.fe_display_result_link
    },
    color: {
      main: t.fe_color_main,
      sub: t.fe_color_sub,
    },
  };
  return item;
}

export const useLogin = () => {
  return useAxios<IUpload, IDownload, IStored>(API_IS_VALIDTOKEN, processing);
};
